const getCategoryId = (location) =>
  location.state?.categoryId ||
  location.pathname.split("categories/")[1].split("/")[0];

export default getCategoryId;
